import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { ProfileService } from '../_services/profile.services';
import { DocumentService } from '../_services/document.services';
import { AddressService } from '../_services/address.services';
import { exhaustMap, map } from 'rxjs/operators';
import { Document } from '../_models/document.model';
import { Profile } from '../_models/profile.model';
import { UserModel } from '../../modules/auth/_models/user.model';
import { AuthService } from '../../modules/auth/_services/auth.service';
import { LayoutService } from '../../_metronic/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})

export class MyProfileComponent implements OnInit {
    @ViewChild("profileModal") profileModal: TemplateRef<any> ;

    loadingModalConfig: NgbModalOptions = {
        backdrop : 'static',
        keyboard : false
    };

    profileHasError: boolean = false;
    extrasUserDropdownStyle: 'light' | 'dark' = 'light';
    user$: Observable<UserModel>;
    _user:UserModel;
    isLoading: boolean;
    templateView: number = 1;
    IdEntidad: number = 1;
    profileForm: FormGroup;
    profileViewForm: FormGroup;
    profile$: any;
    private subscriptions: Subscription[] = [];

  constructor(
    private layout: LayoutService,
    private auth: AuthService,
    public profileService: ProfileService,
    public documentService: DocumentService,
    public addressService: AddressService,
    private updateProfileModal: NgbModal,
    private loadingModal: NgbModal,
    private fb: FormBuilder,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.extrasUserDropdownStyle = this.layout.getProp(
      'extras.user.dropdown.style'
    );
    this.initForm();

    this.user$ = this.auth.currentUserSubject.asObservable();
    this.user$.subscribe(user=> {
      this._user = user;
      //this.profileService.patchState({paramsGet : Array(`IdEntidad=${ this._user.id }`).join('&')});
      this.profile$ = this.profileService.getProfile( Array(`IdEntidad=${ this._user.id }`).join('&') ).then((response:any) => {
        this.profileViewForm.setValue({
            "inputFirstname" : response[0].NombreI,
            "inputSecondname" : response[0].NombreII,
            "inputLastname" : response[0].ApellidoI,
            "inputSecondlastname" : response[0].ApellidoII,
            "inputCedula" : response[0].Cedula,
            "inputEmail" : response[0].Email,
            "inputPhone" : response[0].Telefono,
            "inputMobile" : "",
        });

        return Promise.resolve(response[0]);
      });
      
      if(this.router.url.trim().includes("needupdate")) {
        this.clickUpdateProfile();
      }
     });

    //const sb1 = this.profileService.isLoading$.subscribe(res => this.isLoading = res);
    //this.subscriptions.push(sb1);

    //this.profileService.fetch();
     
    
  }

  initForm() {
    this.profileViewForm = this.fb.group({
        inputFirstname: ['', Validators.compose([Validators.required])], //NombreI
        inputSecondname: [''], //NombreII
        inputLastname: ['', Validators.compose([Validators.required])],
        inputSecondlastname: [''],
        inputEmail: ['', Validators.compose([Validators.required, Validators.email])],// Email
        inputCedula: ['', Validators.compose([Validators.required]) ],
        inputPhone: [''],
        inputMobile: [''],

      });

    this.profileForm = this.fb.group({
      inputFirstname: ['', Validators.compose([Validators.required])], //NombreI
      inputSecondname: [''], //NombreII
      inputLastname: ['', Validators.compose([Validators.required])],
      inputSecondlastname: [''],
      inputEmail: ['', Validators.compose([Validators.required, Validators.email])],// Email
      inputCedula: ['', Validators.compose([Validators.required])]
    });
  }



  clickUpdateProfile(content="") {

    this.profile$ = this.profileService.getProfile( Array(`IdEntidad=${ this._user.id }`).join('&') ).then(response => {

        this.profileForm.setValue({
            "inputFirstname" : response[0].NombreI,
            "inputSecondname" : response[0].NombreII,
            "inputLastname" : response[0].ApellidoI,
            "inputSecondlastname" : response[0].ApellidoII,
            "inputCedula" : response[0].Cedula,
            "inputEmail" : response[0].Email,
        });

        this.updateProfileModal.open(this.profileModal, this.loadingModalConfig);

        return Promise.resolve(response);
    });
  }

  submitUpdateProfile(content) {
    this.profileHasError = false;

    if(this.profileForm.valid) {
      this.loadingModal.open(content, this.loadingModalConfig);

      this.profileService.postProfile({
        "NombreI" : this.profileForm.value.inputFirstname,
        "NombreII": this.profileForm.value.inputSecondname,
        "ApellidoI" : this.profileForm.value.inputLastname,
        "ApellidoII": this.profileForm.value.inputSecondlastname,
        "Cedula" : this.profileForm.value.inputCedula,
        "Email"  : this.profileForm.value.inputEmail
      }).then((response) => {
        this.loadingModal.dismissAll();
        
        //this.profileService.patchState({paramsGet : Array(`IdEntidad=${ this._user.id }`).join('&')});
        window.location.href = "/myprofile";
      })
      .catch(() => {
        alert("Hubo un error al procesar la solicitud. Intente nuevamente.");
      });
    }
    else {
      this.profileHasError = true;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }

}
